import React from "react";
import { Parallax } from "react-parallax";
import { NavHashLink as Link } from "react-router-hash-link";
import logo from "../images/ALLYGN_LOGO_START_SCREEN.svg";
import headerLg from "../images/DSCF2078.JPG";
import "./Header.sass";

function Header() {
  return (
    <header id="header">
      <Parallax bgImage={headerLg} strength={420}>
        <div style={{ height: "100vh" }}>
          <div id="allygn-logo">
            <img src={logo} alt="allygn-logo" style={{ filter: "invert(1)" }} />
          </div>
          <Link
            smooth={true}
            to="#products"
            data-target="#products"
            className="js-scroll-trigger to-products"
          />
        </div>
      </Parallax>
    </header>
  );
}

export default Header;
